import AddToWalletButtonsBlock, {
    AddToWalletButtonBlockType
} from "modules/forms/hosted/blocks/types/AddToWalletButtonsBlock";
import ContactAttributeBlock, {
    ContactAttributeBlockType
} from "modules/forms/hosted/blocks/types/ContactAttributeBlock";
import DividerBlock, { DividerBlockType } from "modules/forms/hosted/blocks/types/DividerBlock";
import ImageBlock, { ImageBlockType } from "modules/forms/hosted/blocks/types/ImageBlock";
import AddToWalletQrCodeBlock, {
    AddToWalletQrCodeBlockType
} from "modules/forms/hosted/blocks/types/AddToWalletQrCodeBlock";
import SpacingBlock, { SpacingBlockType } from "modules/forms/hosted/blocks/types/SpacingBlock";
import StaticBlock, { StaticBlockType } from "modules/forms/hosted/blocks/types/StaticBlock";
import SubscriptionTypeBlock, {
    SubscriptionTypeBlockType
} from "modules/forms/hosted/blocks/types/SubscriptionTypeBlock";
import React, { useMemo } from "react";
import CustomField, { CustomFieldBlockType } from "modules/forms/hosted/blocks/types/CustomField";
import { BlockType, FormBlockType } from "modules/forms/hooks/usefetchForm";
import SubmitButton, { SubmitButtonType } from "modules/forms/hosted/blocks/types/SubmitButton";
import ButtonBlock, { ButtonBlockType } from "modules/forms/hosted/blocks/types/ButtonBlock";

export type BlockMapperProps = {
    block: FormBlockType;
};

export default function BlockMapper(props: BlockMapperProps) {
    const { block } = props;

    delete block.data.default_value;
    delete block.data.hide_label;

    const blocks: Record<BlockType, React.JSX.Element> = useMemo(() => ({
        [BlockType.IMAGE]: <ImageBlock {...block as ImageBlockType} />,
        [BlockType.STATIC]: <StaticBlock {...block as StaticBlockType} />,
        [BlockType.BUTTON]: <ButtonBlock {...block as ButtonBlockType} />,
        [BlockType.DIVIDER]: <DividerBlock {...block as DividerBlockType} />,
        [BlockType.SPACING]: <SpacingBlock {...block as SpacingBlockType} />,
        [BlockType.SUBMIT_BUTTON]: <SubmitButton {...block as SubmitButtonType} />,
        [BlockType.CUSTOM_FIELD]: <CustomField {...block as CustomFieldBlockType} />,
        [BlockType.QR_CODE]: <AddToWalletQrCodeBlock {...block as AddToWalletQrCodeBlockType} />,
        [BlockType.ADD_TO_WALLET]: <AddToWalletButtonsBlock {...block as AddToWalletButtonBlockType} />,
        [BlockType.CONTACT_ATTRIBUTE]: <ContactAttributeBlock {...block as ContactAttributeBlockType} />,
        [BlockType.SUBSCRIPTION_TYPE]: <SubscriptionTypeBlock {...block as SubscriptionTypeBlockType} />,
    }), [block]);

    return blocks[block.type];
}
